import { Face } from '@material-ui/icons'
import React from 'react'
import { checkTKFeatureEnabled, checkCRPFeatureEnabled } from '../../../configs'
import KproSettings from './KproSettings'
import TkAndCrpSettings from './TkAndCrpSettings'


const Settings = props => {
  const { me } = props
  // const tkCrp = checkTKFeatureEnabled(me) || checkCRPFeatureEnabled(me)
  // console.log(tkCrp)
  // return tkCrp ? <TkAndCrpSettings {...props}/> : <KproSettings {...props}/>
  return <TkAndCrpSettings {...props}/>
}

export default Settings



// WEBPACK FOOTER //
// ./src/legacy/pages/Settings/Settings.jsx